import React from 'react'
import { useSelector } from "react-redux";
import styled from "styled-components";

const Content = styled.div`
    width: 100%;
    padding: 20px;
    display: inline-grid;
    margin-top: 0px;
`;

const Tag = styled.h1`
    width: 100%;
    padding: 20px;
    color: white;
`;

function HeaderSearch() {

    let { state: resState } = useSelector((state) => ({
        state: state.reserve,
    }));
    const data = resState.mockTravels[0];
    const directionSourceTitle = data ? data.directionSourceTitle : null
    const directionDestTitle = data ? data.directionDestTitle : null
    return (
        <>
            {
                data
                &&
                <Content className="h-auto p-5 container">
                    <Tag style={{ display: "inherit" }}>
                        بلیط اتوبوس
                        {" " + directionSourceTitle + " "}
                        {" " + directionDestTitle}
                    </Tag>
                </Content>
            }
        </>
    )
}

export default HeaderSearch